import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import UIButton from 'components/ui/form/UIButton';
import UITextField_V2 from 'components/ui/textField/UITextFieldV2';
import { useSelector } from 'react-redux';
import { getCSS } from 'config/helpers/common_helper';
import { useTranslation } from 'react-i18next';

const FormError = ({ error }) => {
  return error ? (
    <Typography color="error" variant="caption">
      {error}
    </Typography>
  ) : null;
};


const SupportContactForm = () => {
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
const theme=useSelector(state=>state?.app?.theme)
  const [focusedField, setFocusedField] = useState(null);
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery(
    "(max-width:767px)"
  );
  
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      subject: '',
      phoneNumber: '',
      details: '',
    },
  });

  const validationRules = {
    subject: {
      required: i18n.t('SUPPORT.SUBJECT_ERROR'),
      maxLength: {
        value: 100,
        message: i18n.t('SUPPORT.SUBJECT_LENGTH_ERROR'),
      },
    },
    phoneNumber: {
      required: i18n.t('SUPPORT.PHONE_ERROR'),
      pattern: {
        value: /^[0-9+\-\s()]*$/,
        message: i18n.t('SUPPORT.PHONE_LENGTH_ERROR'),
      },
    },
    details: {
      required: i18n.t('SUPPORT.DETAILS_ERROR'),
      maxLength: {
        value: 1000,
        message: i18n.t('SUPPORT.DETAILS_LENGTH_ERROR'),
      },
    },
  };

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const onSubmit = async (data) => {
    console.log(data);
  };

  return (
      <div className="support-form-bg mt-5" >
        <div className='my-3 fs-5'>
          {i18n.t('SUPPORT.SUBMIT_TICKET')}
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{ margin: '1vw 0px' }}>
            <Controller
              control={control}
              name="subject"
              rules={validationRules.subject}
              render={({ field }) => (
                <UITextField_V2
                  {...field}
                  label={i18n.t('SUPPORT.SUBJECT')}
                  placeholder={i18n.t('SUPPORT.SUBJECT_PLACEHOLDER')}
                  variant="filled"
                  onFocus={() => handleFocus('subject')}
                  onBlur={handleBlur}
                  sx={{
                    // ...customStyleInput,
                    ...getCSS(theme),
                    width: '100%',
                    '.MuiFilledInput-input': {
                      // ...customStyleInput['.MuiFilledInput-input'],
                      ...getCSS(theme)['.MuiFilledInput-input'],
                      height: focusedField === 'subject' || field.value ? '4.5vh' : '3vh',
                      background:theme==='dark'&&"#201F47 !important"
                    },
                    '.MuiInputLabel-root': {
                      ...getCSS(theme)['.MuiInputLabel-root'],
                      paddingTop: focusedField === 'subject' || field.value ? '1vh' : '0.5vh',
                    },
                  }}
                />
              )}
            />
            <FormError error={errors?.subject?.message} />
          </div>

          <div style={{ margin: '1vw 0px' }}>
            <Controller
              control={control}
              name="phoneNumber"
              rules={validationRules.phoneNumber}
              render={({ field }) => (
                <UITextField_V2
                  {...field}
                  label={i18n.t('SUPPORT.PHONE_NUMBER')}
                  placeholder={i18n.t('SUPPORT.PHONE_PLACEHOLDER')}
                  variant="filled"
                  onFocus={() => handleFocus('phoneNumber')}
                  onBlur={handleBlur}
                  sx={{
                    ...getCSS(theme),
                    width: '100%',
                    '.MuiFilledInput-input': {
                      ...getCSS(theme)['.MuiFilledInput-input'],
                      height: focusedField === 'phoneNumber' || field.value ? '4.5vh' : '3vh',
                      background:theme==='dark'&&"#201F47 !important"
                    },
                    '.MuiInputLabel-root': {
                      ...getCSS(theme)['.MuiInputLabel-root'],
                      paddingTop: focusedField === 'phoneNumber' || field.value ? '1vh' : '0.5vh',
                    },
                  }}
                />
              )}
            />
            <FormError error={errors?.phoneNumber?.message} />
          </div>

          <div style={{ margin: '1vw 0px' }}>
            <Controller
              control={control}
              name="details"
              rules={validationRules.details}
              render={({ field }) => (
                <UITextField_V2
                  {...field}
                  label={i18n.t('SUPPORT.DETAILS')}
                  placeholder={i18n.t('SUPPORT.DETAILS_PLACHOLDER')}
                  variant="filled"
                  multiline
                  rows={6}
                  onFocus={() => handleFocus('details')}
                  onBlur={handleBlur}
                  sx={{
                    ...getCSS(theme),
                    width: '100%',
                    '.MuiFilledInput-input': {
                      ...getCSS(theme)['.MuiFilledInput-input'],
                      minHeight: '0.5vh',
                      background: theme==='dark'&&"#201F47 !important",
                      marginTop:'1vh'
                    },
                    '.MuiInputLabel-root': {
                      ...getCSS(theme)['.MuiInputLabel-root'],
                      paddingTop: focusedField === 'details' || field.value ? '1vh' : '0.5vh',
                    },
                  }}
                />
              )}
            />
            <FormError error={errors?.details?.message} />
          </div>

          <div>
            <UIButton
              text={isSubmitting ? '' : i18n.t('SUPPORT.SUBMIT')}
              sx={{
                padding: '0 !important',
                gap: '0 !important',
                margin: '1.5vw 0 0.5vw 0 !important',
                height: 'clamp(2.8vh, 2.8vw, 2.8vw) !important',
                fontSize: isMobile ? '1.3vh' : 'clamp(0.9vh, 0.9vw, 0.9vw)',
                '&:disabled': {
                  backgroundColor: 'rgba(117, 23, 198, 0.3) !important',
                  color: 'rgba(209, 211, 212, 0.3) !important',
                },
              }}
              customStyles={styles.submitButtonStyles}
              type="submit"
              loading={isSubmitting}
              loadingIndicator={
                <Typography
                  sx={{
                    color: '#9E9E9E !important',
                    fontSize: 'clamp(0.9vh, 0.9vw, 0.9vw)',
                  }}
                >
                  Submitting...
                </Typography>
              }
            />
          </div>
        </form>
      </div>
  );
};

const styles = {
  submitButtonStyles: {
    display: 'flex',
    height: '50px',
    justifyContent: 'center',
    gap: '10px',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '10vw',
    background: '#5D5FEF',
    width: '100%',
    margin: '10px 0',
  },
};

export default SupportContactForm;